import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const rowDefault = {
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: ['12px', '12px', '12px', '24px']
};
const getAnimationItem = {
  'a, button': {
    '> div:nth-of-type(1)': {
      transform: 'translateY(100%)',
      ...reusables.mainTransition('transform', '2s')
    }
  }
};
const itemDefault = (textHoverColor: string | undefined, bgHoverColor: string | undefined, animation?: string | undefined) => ({
  position: 'relative',
  overflow: 'hidden',
  boxSizing: 'border-box',
  // WCAG 2.4.7 Focus Visible - użyj box-shadow na kontenerze
  // który będzie widoczny poza overflow: hidden
  '&.has-focus-visible': {
    boxShadow: `0 0 0 2px ${theme.rawColors.blue500}`,
    outline: 'none'
  },
  // Fallback dla przeglądarek wspierających :has()
  '&:has(a:focus-visible), &:has(button:focus-visible)': {
    boxShadow: `0 0 0 2px ${theme.rawColors.blue500}`,
    outline: 'none'
  },
  a: {
    '&:focus-visible': {
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none'
    }
  },
  button: {
    '&:focus-visible': {
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none'
    }
  },
  img: {
    ...reusables.mainTransition('opacity')
  },
  ...reusables.mainTransition('opacity'),
  ...(animation !== 'fadeIn' && {
    ...getAnimationItem
  }),
  '&:hover': {
    color: textHoverColor || theme.rawColors.darkGrey700,
    backgroundColor: bgHoverColor || theme.rawColors.beige500,
    'a, button': {
      '> div:nth-of-type(1)': {
        opacity: '1',
        transform: 'translateY(0)'
      },
      'div:nth-of-type(2)': {
        opacity: ['0', '0', '0', '1'],
        transform: 'translateX(0)',
        'h1, h3, h6, h7': {
          opacity: ['0', '0', '0', '1']
        }
      },
      svg: {
        path: {
          fill: textHoverColor ? `${textHoverColor} !important` : `${theme.rawColors.darkGrey700} !important`
        }
      }
    }
  }
});
const itemDescription = {
  position: 'relative',
  overflow: 'hidden',
  boxSizing: 'border-box',
  opacity: '1',
  // WCAG 2.4.7 Focus Visible - użyj box-shadow zamiast outline
  a: {
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}, 0 0 0 4px ${theme.rawColors.blue500}`,
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    }
  },
  button: {
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}, 0 0 0 4px ${theme.rawColors.blue500}`,
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    }
  },
  'div:nth-of-type(2)': {
    width: 'max-content',
    opacity: '1',
    transform: 'translateX(0)',
    'h1, h3, h6, h7': {
      opacity: '1'
    }
  }
};
const itemDescriptionBgImg = {
  position: 'relative',
  overflow: 'hidden',
  boxSizing: 'border-box',
  opacity: '1',
  // WCAG 2.4.7 Focus Visible - użyj box-shadow zamiast outline
  a: {
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}, 0 0 0 4px ${theme.rawColors.blue500}`,
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    }
  },
  button: {
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}, 0 0 0 4px ${theme.rawColors.blue500}`,
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    }
  },
  'div:nth-of-type(2)': {
    width: 'max-content',
    opacity: '1',
    transform: 'translateX(0)',
    'h1, h3, h6, h7': {
      opacity: '1'
    }
  },
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
};
const itemHeadingTextBgImg = {
  position: 'relative',
  overflow: 'hidden',
  boxSizing: 'border-box',
  // WCAG 2.4.7 Focus Visible - użyj box-shadow zamiast outline
  a: {
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}, 0 0 0 4px ${theme.rawColors.blue500}`,
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    }
  },
  button: {
    '&:focus-visible': {
      boxShadow: `0 0 0 2px ${theme.rawColors.blue500}, 0 0 0 4px ${theme.rawColors.blue500}`,
      outline: 'none',
      zIndex: 1
    },
    '&:focus:not(:focus-visible)': {
      outline: 'none',
      boxShadow: 'none'
    }
  },
  img: {
    ...reusables.mainTransition('opacity')
  },
  ...reusables.mainTransition('opacity'),
  '&:hover': {
    'div:nth-of-type(1)': {
      opacity: '1'
    },
    'div:nth-of-type(2)': {
      opacity: ['0', '0', '0', '1'],
      width: '100%',
      a: {
        color: theme.rawColors.darkGrey700
      }
    }
  },
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  'h1, h7': {
    textTransform: 'none !important'
  }
};
const getItemVariantStyle = (variant: string, textHoverColor: string | undefined, bgHoverColor: string | undefined, animation?: string | undefined) => {
  switch (variant) {
    case 'description':
      return itemDescription;
    case 'headingBgImg':
      return itemHeadingTextBgImg;
    case 'textBgImg':
      return itemHeadingTextBgImg;
    case 'descriptionBgImg':
      return itemDescriptionBgImg;
    default:
      return itemDefault(textHoverColor, bgHoverColor, animation);
  }
};
const getColorsItem = (textColor: string | undefined, bgColor: string | undefined, showItem: boolean) => ({
  color: textColor || theme.rawColors.darkGrey700,
  ...(showItem && {
    backgroundColor: bgColor || theme.rawColors.beige500
  })
});
export default {
  section: (bg?: string, marginTop?: string, marginBottom?: string) => ({
    bg,
    mt: marginTop || 0,
    mb: marginBottom || 0,
    width: '100%',
    p: ['64px 16px', '64px 16px', '80px 24px', '40px'],
    position: 'relative',
    zIndex: 1
  }),
  styledLayout: (layout: string, showItem: boolean, itemVariant: string, textColor: string | undefined, textHoverColor: string | undefined, bgColor: string | undefined, bgHoverColor: string | undefined, animation?: string | undefined) => {
    switch (layout) {
      default:
      case '50x50':
        return {
          ...rowDefault,
          flexDirection: ['column', 'column', 'row'],
          item: {
            ...getItemVariantStyle(itemVariant, textHoverColor, bgHoverColor, animation),
            ...getColorsItem(textColor, bgColor, showItem),
            width: ['100%', '100%', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 12px)'],
            height: ['calc(100vw - 47px)', 'calc(100vw - 47px)', '58.203125vw', '58.203125vw', '29.166666667vw'],
            opacity: showItem ? 1 : 0,
            '&:first-of-type': {
              marginRight: [0, 0, '8px', '12px']
            },
            '&:last-of-type': {
              marginLeft: [0, 0, '8px', '12px'],
              marginTop: ['12px', '12px', 0]
            }
          }
        };
      case '25x75':
        return {
          ...rowDefault,
          flexDirection: ['column', 'column', 'column', 'row'],
          item: {
            ...getItemVariantStyle(itemVariant, textHoverColor, bgHoverColor, animation),
            ...getColorsItem(textColor, bgColor, showItem),
            opacity: showItem ? 1 : 0,
            '&:last-of-type': {
              width: ['100%', '100%', '100%', '100%', '63.489583333vw'],
              marginLeft: [0, 0, 0, '12px'],
              height: ['calc(100vw - 47px)', 'calc(100vw - 47px)', '58.203125vw', '58.203125vw', '29.166666667vw']
            },
            '&:first-of-type': {
              width: ['100%', '100%', '100%', '100%', '31.09375vw'],
              marginRight: [0, 0, 0, '12px'],
              marginBottom: ['12px', '12px', '12px', 0],
              height: ['calc(100vw - 47px)', 'calc(100vw - 47px)', '58.203125vw', '58.203125vw', '29.166666667vw']
            }
          }
        };
      case '75x25':
        return {
          ...rowDefault,
          flexDirection: ['column', 'column', 'column', 'row'],
          item: {
            ...getItemVariantStyle(itemVariant, textHoverColor, bgHoverColor, animation),
            ...getColorsItem(textColor, bgColor, showItem),
            opacity: showItem ? 1 : 0,
            '&:last-of-type': {
              width: ['100%', '100%', '100%', '100%', '31.09375vw'],
              marginLeft: [0, 0, 0, '12px'],
              height: ['calc(100vw - 47px)', 'calc(100vw - 47px)', '58.203125vw', '58.203125vw', '29.166666667vw']
            },
            '&:first-of-type': {
              width: ['100%', '100%', '100%', '63.489583333vw'],
              marginRight: [0, 0, 0, '12px'],
              marginBottom: ['12px', '12px', '12px', 0],
              height: ['calc(100vw - 47px)', 'calc(100vw - 47px)', '58.203125vw', '58.203125vw', '29.166666667vw']
            }
          }
        };
      case '25x25x25x25':
        return {
          ...rowDefault,
          flexDirection: 'row',
          flexWrap: ['wrap', 'wrap', 'wrap', 'nowrap'],
          item: {
            ...getItemVariantStyle(itemVariant, textHoverColor, bgHoverColor, animation),
            ...getColorsItem(textColor, bgColor, showItem),
            opacity: showItem ? 1 : 0,
            height: ['58.203125vw', '58.203125vw', '58.203125vw', '58.203125vw', '29.166666667vw'],
            marginBottom: ['12px', '12px', '12px', 0],
            '&:nth-of-type(1)': {
              width: ['calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(25% - 18px)'],
              marginRight: ['8px', '8px', '8px', '12px'],
              marginLeft: 0
            },
            '&:nth-of-type(2)': {
              width: ['calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(25% - 18px)'],
              marginRight: [0, 0, 0, '12px'],
              marginLeft: ['8px', '8px', '8px', '12px']
            },
            '&:nth-of-type(3)': {
              width: ['calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(25% - 18px)'],
              marginRight: ['8px', '8px', '8px', '12px'],
              marginLeft: [0, 0, 0, '12px']
            },
            '&:nth-of-type(4)': {
              width: ['calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(50% - 8px)', 'calc(25% - 18px)'],
              marginRight: 0,
              marginLeft: ['8px', '8px', '8px', '12px']
            }
          }
        };
    }
  },
  descriptionContainer: (color: string | null, lineSpacing = 16) => ({
    color,
    'h1, h2, h3, h6, h7': {
      mb: `${lineSpacing}px`,
      color
    },
    'p, ul': {
      mb: `${lineSpacing}px`,
      color
    }
  }),
  heading: (up = false) => ({
    position: 'absolute',
    bottom: ['20px', '30px', '40px', '40px'],
    left: ['20px', '30px', '40px', '40px'],
    width: ['55%', '55%', 'calc(100% - 130px)'],
    height: 'auto',
    textAlign: 'left !important',
    zIndex: up ? 3 : 1
  }),
  catalogCard: (isLink: boolean, bg = true, opacity = 0, textColor: string | undefined, bgColor: string | undefined) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    bg: bg ? bgColor || theme.rawColors.beige500 : 'none',
    padding: ['20px', '30px', '40px'],
    color: textColor || theme.rawColors.darkGrey700,
    zIndex: 2,
    cursor: isLink ? 'pointer' : 'unset',
    textAlign: 'left',
    opacity,
    '&:hover': {
      opacity: '1 !important'
    },
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    ...reusables.mainTransition('opacity'),
    div: {
      maxWidth: '500px',
      marginTop: 20,
      fontSize: ['12px', '14px', '16px', '16px'],
      lineHeight: ['24px', '26px', '28px', '28px'],
      overflow: 'hidden',
      maxHeight: ['242px', '242px', '280px', '140px', '160px', '280px'],
      textOverflow: 'ellipsis',
      p: {
        textAlign: 'left'
      }
    }
  }),
  styledViewFileLink: (color: string | null, hasIcon = true) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'absolute',
    width: ['20px', '22px', '24px', 'min-content'],
    bottom: ['16px', '16px', '40px', '40px'],
    right: ['20px', '30px', '30px', '30px'],
    height: ['20px', '22px', '24px', '30px'],
    overflow: 'hidden',
    transform: ['20px', '22px', '24px', 'translateX(calc(100% - 30px))'],
    zIndex: 3,
    color,
    pl: hasIcon ? 0 : ['32px', '34px', '36px', '46px'],
    opacity: '1',
    ...reusables.mainTransition('all'),
    'h1, h3, h6, h7': {
      opacity: 0
    },
    svg: {
      width: ['24px !important', '24px !important', '24px !important', '40px !important'],
      height: 'auto',
      marginRight: ['12px', '12px', '12px', '16px'],
      path: {
        fill: color ? `${color} !important` : `${theme.rawColors.darkGrey700} !important`
      }
    }
  })
};